import EventEmitter from 'eventemitter3'
import { debounce } from 'throttle-debounce'

const WAIT = 200

const bus = new EventEmitter()

window.addEventListener('resize', debounce(() => {
  bus.emit('resize')
}, WAIT))

const onresize = (fn) => {
  bus.on('resize', fn)
  return () => bus.off('resize', fn)
}

export default onresize
